.container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (--reefer-media-tablet-min) {
    flex-direction: row;
    gap: 24px;
  }
}

.textField {
  @media (--reefer-media-tablet-min) {
    margin-left: 0;
  }
}
